import React from 'react';

export const Button = ({text, onPress, buttonDisabled }) => {
    return (
        <button onClick={onPress} disabled={buttonDisabled}>
            {text}
        </button>
    );
};